import React, { useState, useEffect } from "react";
import {
  Backdrop,
  Box,
  Modal,
  Fade,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { serverUrl } from "../../temp";
import "./modal.scss";

const AddNumberModal = ({
  open,
  onClose,
  student,
  examination_id,
  center_id,
}) => {
  const [inputValues, setInputValues] = useState({
    obtain_number: "",
  });
  const [loading, setLoading] = useState(false);
  const [existingResult, setExistingResult] = useState(null);
  const total_marks = parseInt(localStorage.getItem("total_marks"), 10) || 100;
  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    const fetchExistingNumber = async () => {
      if (!open) return;

      setLoading(true);
      try {
        const response = await fetch(
          `${serverUrl}/get_awardlist?student_id=${student.id}&examination_id=${examination_id}`
        );
        const data = await response.json();

        if (data.status === "true") {
          setExistingResult(data.data);
          setInputValues({
            obtain_number: data.data.obtain_number || "",
          });
        } else {
          setExistingResult(null);
          setInputValues({ obtain_number: "" });
        }
      } catch (error) {
        console.error("Error fetching student award data:", error);
        toast.error("Failed to load student data");
      } finally {
        setLoading(false);
      }
    };

    fetchExistingNumber();
  }, [open, student.id]);

  const calculateGradeAndRemarks = (percentage) => {
    if (percentage >= 90) return { grade: "A+", remarks: "Marvelous" };
    if (percentage >= 80) return { grade: "A+", remarks: "Excellent" };
    if (percentage >= 70) return { grade: "A", remarks: "Very Good" };
    if (percentage >= 60) return { grade: "B", remarks: "Fair" };
    if (percentage >= 50) return { grade: "C", remarks: "Average" };
    return { grade: "D", remarks: "Need Improvement" };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const percentage =
      (parseFloat(inputValues.obtain_number) / total_marks) * 100;
    const { grade, remarks } = calculateGradeAndRemarks(percentage);

    const formData = new FormData();
    formData.append("center_id", center_id);
    formData.append("student_id", student.id);
    formData.append("examination_id", examination_id);
    formData.append("user_id", user_id);
    formData.append("obtain_number", inputValues.obtain_number);
    formData.append("status", 1);
    formData.append("grade", grade);
    formData.append("remarks", remarks);

    try {
      const url = existingResult
        ? `${serverUrl}/upd_awardlist/${existingResult.id}`
        : `${serverUrl}/add_awardlist`;

      const method = existingResult ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        body: formData,
      });

      const data = await response.json();
      if (data.code >= 400) {
        throw new Error(data.message || "Operation failed");
      }

      toast.success(
        existingResult
          ? "Number updated successfully!"
          : "Number added successfully!"
      );
      onClose(true);
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => onClose(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={open}>
        <Box className="custom-modal">
          <Typography variant="h5">
            {existingResult ? "Update" : "Add"} Number for {student.name}
          </Typography>

          {loading ? (
            <div className="loading-spinner">
              <CircularProgress />
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <TextField
                type="number"
                label="Obtained Number"
                value={inputValues.obtain_number}
                onChange={(e) =>
                  setInputValues({
                    obtain_number: e.target.value,
                  })
                }
                fullWidth
                margin="normal"
                inputProps={{
                  min: 0,
                  max: total_marks,
                  step: "0.01",
                }}
                required
              />

              <div className="modal-actions">
                <Button onClick={() => onClose(false)}>Cancel</Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                >
                  {existingResult ? "Update" : "Save"}
                </Button>
              </div>
            </form>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default AddNumberModal;
